/**
 * Componente: StepNavigation
 * Botões de navegação entre steps
 */

import React from 'react';

interface StepNavigationProps {
  onNext: () => void;
  onPrevious: () => void;
  nextLabel?: string;
  previousLabel?: string;
  nextDisabled?: boolean;
  previousDisabled?: boolean;
  isLoading?: boolean;
  showPrevious?: boolean;
  className?: string;
}

export const StepNavigation: React.FC<StepNavigationProps> = ({
  onNext,
  onPrevious,
  nextLabel = 'Próximo',
  previousLabel = 'Anterior',
  nextDisabled = false,
  previousDisabled = false,
  isLoading = false,
  showPrevious = true,
  className = '',
}) => {
  return (
    <div className={`step-navigation ${className}`}>
      {showPrevious && (
        <button
          type="button"
          className="btn-previous"
          onClick={onPrevious}
          disabled={previousDisabled || isLoading}
        >
          ← {previousLabel}
        </button>
      )}
      <button
        type="button"
        className="btn-next"
        onClick={onNext}
        disabled={nextDisabled || isLoading}
      >
        {isLoading ? 'Carregando...' : nextLabel} →
      </button>
    </div>
  );
};

export default StepNavigation;
